import React, { Component } from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';

import styles from './Search.module.css';

const cx = classNames.bind(styles);

class Seats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      sticky: false,
    };

    this.onHandleSubmit = this.onHandleSubmit.bind(this);
    this.onExpandToggle = this.onExpandToggle.bind(this);
    this.onLocationClicked = this.onLocationClicked.bind(this);
    this.getDateButtonText = this.getDateButtonText.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    let isFilled = window.scrollY > 0 ? true : false;

    this.setState({
      showBackground: isFilled
    });
  }

  onHandleSubmit(e) {
    if (e.target.value.length > 0) {
      this.setState({ searching: true });
    } else {
      this.setState({ searching: false });
    }

    if (e.key === 'Enter') {
      this.props.setLongHaul(false);
      this.props.history.push('/flights');
      this.setState({ expanded: false });
      document.activeElement.blur();
    }
  }

  onExpandToggle(e) {
    if (e && e.target.classList.contains(styles.searchInputArrowIcon)) {
      // if the target of the click event is a back arrow img, load the previous page
      return this.props.history.goBack();
    }

    const expandedInput = document.getElementById('expandedSearchInput');

    if (e && e.target.classList.contains(styles.closeButton)) {
      document.activeElement.blur();
      expandedInput.blur();
    }

    if (!this.state.expanded) {
      expandedInput.focus();
      this.refs.expandedInput.value = '';
    } 

    this.setState({ expanded: !this.state.expanded });
  }

  onLocationClicked(e) {
    this.props.setLongHaul(false);
    this.onExpandToggle(e);
  }

  getDateButtonText() {
    if (this.props.startDate && this.props.endDate) {
      return `${this.props.startDate.format('MMMM D')} - ${this.props.endDate.format('D')}`;
    } else if (this.props.startDate) {
      return `${this.props.startDate.format('MMMM D')}`;
    }
    return 'Date';
  }

  formatDirection(string){
    let directionArray = string.split(' ');
    let formattedDirection = '';
    directionArray.forEach((item, index) => {
       formattedDirection += (item.charAt(0).toUpperCase() + item.slice(1) + ' ');
    })
    directionArray.join(' ');
    if(this.props.isLongHaul) {
      return 'San Francisco → Sydney'
    } else {
      return 'San Francisco → Santa Barbara';
    }
  }

  render() {

    const { direction } = this.props.match.params;

    const matchPath = this.props.match.path
    const isLongHaul = this.props.isLongHaul;
    const showSecondary = !(matchPath.indexOf('/flights/browse') > -1) && !(matchPath === '/');
    const isFlightsPath = this.props.match.path === '/flights';

    const expandedSearchStyles = cx({
      expandedSearch: true,
      expanded: this.state.expanded,
      searching: this.state.searching
    });

    const searchInputWrapperStyles = cx({
      searchInputWrapper: true,
      isFilled: this.state.showBackground,
    })

    const dateButtonStyles = cx({
      selected: this.props.startDate,
      secondaryButton: isFlightsPath
    });

    const passengersButtonStyles = cx({
      selected: this.props.passengers.length > 0,
      secondaryButton: isFlightsPath
    });

    const moreFilterButtonStyles = cx({
      secondaryButton: isFlightsPath
    })

    return (
      <div className={styles.search}>
        <div onClick={this.onExpandToggle} className={searchInputWrapperStyles}>
          {showSecondary ? 
            <img className={styles.searchInputArrowIcon} src={require('./img/left-arrow.png')} alt="" /> 
              : this.props.match.path.indexOf('/flights/browse') > -1 ? <img className={styles.searchInputArrowIcon} src={require('./img/left-arrow.png')} alt="" /> : <img className={styles.searchInputMagnifyIcon} src={require('./img/magnifying-glass.png')} alt="" />  }
          { !direction ? 
              <input className={styles.searchInput} value={matchPath === ('/flights') && isLongHaul ? 'Flights to Sydney' : matchPath === '/flights' ? 'San Francisco → Santa Barbara' : '' } placeholder={matchPath.indexOf('/flights/browse') > -1 ? 'Where do you want to go?' : 'Try "Algarve"'} disabled />
            : <input className={styles.searchInput} value={this.formatDirection(direction)} disabled />
          }
        </div>

        <div className={styles.searchButtonsWrapper} >
          <div className={styles.searchButtons} >
            <Link className={dateButtonStyles} to="/flights/calendar" >{this.getDateButtonText()}</Link>
            <Link className={passengersButtonStyles} to="/flights/passengers" >{this.props.passengers.length ? `${this.props.passengers.length} Passengers` : 'Passengers'}</Link>
            <Link className={moreFilterButtonStyles} to="#">More Filters</Link>
          </div>
        </div>

        <div className={expandedSearchStyles}>
          <div className={styles.closeButton} onClick={this.onExpandToggle}>Close</div>
          <input id="expandedSearchInput" className={styles.searchInput + ' ' + styles.expandedSearchInput } ref='expandedInput' placeholder='Try "Algarve"' onKeyUp={this.onHandleSubmit} />
          {/* <hr/> */}
          <div className={[styles.results, styles.suggestions].join(' ')}>
            <Link className={styles.location} to="/">Anywhere</Link>
            <Link className={styles.location} to="/">Nearby</Link>
            <Link className={styles.time} to="/">Barcelona - 1 Guest</Link>
            <Link className={styles.time} to="/">New York - 1 Guest</Link>
            <Link className={styles.time} to="/">Bar - 1 Guest</Link>
          </div>
          <div className={styles.results}>
            <Link className={styles.location} to="/flights" onClick={this.onlocationclicked}>Santa Barbara, CA, United States</Link>
            <Link className={styles.home} to="/">Homes in Santa Barbara, CA, United States</Link>
            <Link className={styles.flight} to="/flights" onClick={this.onlocationclicked}>flights to Santa Barbara, Ca, United States</Link>
            <Link className={styles.experience} to="/">Experiences in Santa Barbara, CA, United States</Link>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ main }) => ({
  isLongHaul: main.isLongHaul,
  startDate: main.startDate,
  endDate: main.endDate,
  passengers: main.passengers,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setLongHaul: data =>
      dispatch({
        type: 'SET_LONGHAUL',
        payload: data,
      }),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Seats));



// WEBPACK FOOTER //
// ./src/components/Search/Search.jsx